function alignSidebarFootnotes() {
  const sidebarFootnotes = document.querySelectorAll('[data-footnote-index]');
  if (sidebarFootnotes.length === 0) return;

  const mainContent = document.querySelector('.article-main-content');
  if (!mainContent) return;

  const mainContentRect = mainContent.getBoundingClientRect();
  let cumulativeOffset = 0;

  sidebarFootnotes.forEach((sidebarNote) => {
    const sidebarFootnoteIndex = sidebarNote.getAttribute('data-footnote-index');
    const mainTextRef = document.getElementById(`fnref:${sidebarFootnoteIndex}`);

    if (mainTextRef) {
      const refRect = mainTextRef.getBoundingClientRect();
      const relativeTop = refRect.top - mainContentRect.top;

      const targetOffset = Math.max(0, relativeTop - cumulativeOffset);

      sidebarNote.style.position = 'static';
      sidebarNote.style.marginTop = `${targetOffset}px`;

      const noteRect = sidebarNote.getBoundingClientRect();
      cumulativeOffset += targetOffset + noteRect.height;
    } else {
      sidebarNote.style.position = 'static';
      sidebarNote.style.marginTop = '0';
    }
  });
}

function updateActiveTocItem() {
  const tocLinks = document.querySelectorAll('[data-toc-link]');
  if (tocLinks.length === 0) return;

  const headings = Array.from(document.querySelectorAll('h2, h3, h4, h5, h6')).filter(h => h.id);
  if (headings.length === 0) return;

  let currentHeading = null;
  const scrollTop = window.scrollY;
  const offset = 100;

  for (let i = headings.length - 1; i >= 0; i--) {
    const heading = headings[i];
    const rect = heading.getBoundingClientRect();
    const headingTop = scrollTop + rect.top;

    if (scrollTop + offset >= headingTop) {
      currentHeading = heading;
      break;
    }
  }

  tocLinks.forEach(link => {
    link.classList.remove('active');
  });

  if (currentHeading) {
    const activeLink = document.querySelector(`[data-toc-link="${currentHeading.id}"]`);
    if (activeLink) {
      activeLink.classList.add('active');
      activeLink.scrollIntoView({ block: 'nearest' });
    }
  }
}

function initFootnoteAlignment() {
  const sidebarFootnotes = document.querySelectorAll('[data-footnote-index]');
  if (sidebarFootnotes.length === 0) return;

  const mainContent = document.querySelector('.article-main-content');
  if (!mainContent) return;

  alignSidebarFootnotes();

  window.addEventListener('load', alignSidebarFootnotes);

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(alignSidebarFootnotes, 200);
  });
}

function initHeadingLinks() {
  const content = document.querySelector('.article-main-content');
  if (!content) return;

  content.querySelectorAll('h2, h3, h4, h5, h6').forEach(heading => {
    if (!heading.id) return;
    const link = document.createElement('a');
    link.href = `#${heading.id}`;
    link.className = 'heading-anchor';
    while (heading.firstChild) link.appendChild(heading.firstChild);
    heading.appendChild(link);
  });
}

function initTocHighlighting() {
  const tocLinks = document.querySelectorAll('[data-toc-link]');
  if (tocLinks.length === 0) return;

  updateActiveTocItem();

  let scrollTimeout;
  window.addEventListener('scroll', () => {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(updateActiveTocItem, 100);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initFootnoteAlignment();
    initHeadingLinks();
    initTocHighlighting();
  });
} else {
  initFootnoteAlignment();
  initHeadingLinks();
  initTocHighlighting();
}
